import { HttpContext, HttpContextToken } from '@angular/common/http';

export const API_MESSAGE_DISPLAY = new HttpContextToken<boolean>(() => true);

export function apiMessageOptions(showMessage: boolean = true): { context: HttpContext } {
    return {
        context: new HttpContext().set(API_MESSAGE_DISPLAY, showMessage)
    };
}
